import React from 'react'
import { FeatureContainer, FeatureButton} from './FetureElement'
const Feture = () => {
    return (
        <FeatureContainer>
            <h1> Dish of the day</h1>
            <p> Hand-made cosuine with greate taste with 
                Vietname culture</p>
        <FeatureButton> Order Now</FeatureButton>        
        </FeatureContainer>
    )
}

export default Feture
